import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'International',
  props: {
    title: null,
    seasonNumber: null,
    allRegularOffers: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	seasonNumber?: number | null;
	allRegularOffers: TitleDetail['offers'];
};



const { t, tc } = useI18n();
const { country, language } = storeToRefs(useLanguageStore());

const text = computed(() => {
	const displayedTitle =
		props.seasonNumber == null ? props.title : `${props.title} - ${tc('WEBAPP_SEASON')} ${props.seasonNumber}`;
	const providers = props.allRegularOffers.map(offer => offer.package.clearName);
	const countries = props.allRegularOffers.map(offer => offer.country);
	const uniqueProviders = [...new Set(providers)];
	const uniqueCountries = [...new Set(countries)];

	if (uniqueCountries.length === 1) {
		if (uniqueProviders.length < 4) {
			return t('WEBAPP_3ORLESS_INTERNATIONAL_OFFERS_1_COUNTRY', {
				providers: uniqueProviders.join(', '),
				country: getCountryName(country.value, language.value),
				firstCountry: getCountryName(uniqueCountries[0], language.value),
				title: displayedTitle,
			});
		}
		return t('WEBAPP_4ORMORE_INTERNATIONAL_OFFERS_1_COUNTRY', {
			firstProvider: uniqueProviders[0],
			secondProvider: uniqueProviders[1],
			country: getCountryName(country.value, language.value),
			firstCountry: getCountryName(uniqueCountries[0], language.value),
			title: displayedTitle,
			countRestOfServices: uniqueProviders.length - 2,
		});
	}
	if (uniqueCountries.length === 2) {
		if (uniqueProviders.length < 4) {
			return t('WEBAPP_3ORLESS_INTERNATIONAL_OFFERS_2_COUNTRIES', {
				title: displayedTitle,
				country: getCountryName(country.value, language.value),
				firstCountry: getCountryName(uniqueCountries[0], language.value),
				secondCountry: getCountryName(uniqueCountries[1], language.value),
				providers: uniqueProviders.join(', '),
			});
		}
		return t('WEBAPP_4ORMORE_INTERNATIONAL_OFFERS_2_COUNTRIES', {
			title: displayedTitle,
			country: getCountryName(country.value, language.value),
			firstCountry: getCountryName(uniqueCountries[0], language.value),
			secondCountry: getCountryName(uniqueCountries[1], language.value),
			firstProvider: uniqueProviders[0],
			secondProvider: uniqueProviders[1],
			countRestOfServices: uniqueProviders.length - 2,
		});
	}

	if (uniqueProviders.length < 4) {
		return t('WEBAPP_3ORLESS_INTERNATIONAL_OFFERS_3ORMORE_COUNTRIES', {
			title: displayedTitle,
			country: getCountryName(country.value, language.value),
			firstCountry: getCountryName(uniqueCountries[0], language.value),
			countRestOfCountries: uniqueCountries.length - 1,
			providers: uniqueProviders.join(', '),
		});
	}

	return t('WEBAPP_4ORMORE_INTERNATIONAL_OFFERS_3ORMORE_COUNTRIES', {
		title: displayedTitle,
		country: getCountryName(country.value, language.value),
		firstCountry: getCountryName(uniqueCountries[0], language.value),
		countRestOfCountries: uniqueCountries.length - 1,
		firstProvider: uniqueProviders[0],
		secondProvider: uniqueProviders[1],
		countRestOfServices: uniqueProviders.length - 2,
	});
});

function getCountryName(countryCode: string, lang: string) {
	// these countries have a "the" in front of their country in english, e.g. "Let us notify you when you can watch it in the United States".
	const countriesWithThe = ['US', 'GB', 'NL', 'PH', 'BS', 'MV', 'SC', 'KM', 'MH', 'SB', 'FM', 'CZ', 'CF', 'DO', 'AE'];
	if (countriesWithThe.includes(countryCode) && lang === 'en') {
		return 'the ' + t(`WEBAPP_COUNTRY_${countryCode.toUpperCase()}`);
	}
	return t(`WEBAPP_COUNTRY_${countryCode.toUpperCase()}`);
}

return { __sfc: true,props, t, tc, country, language, text, getCountryName }
}

})